import { c as _c } from "react/compiler-runtime";
import type { PublicUser } from '@sbt-web/auth';
import { CategoryID, type AdItem } from '@sbt-web/network/types';
import { FullModal } from '@sbt-web/ui';
import type { SearchData } from '../../types';
import { Form } from './form';
import { ProLeadForm } from './ProLeadForm';
interface ContactFormProps {
  isMobile: boolean;
  onCloseContactForm: () => void;
  isPro: boolean;
  category: string;
  enableAttachments: boolean;
  userId: string;
  advertiserName: string;
  subject: string;
  adUrn: string;
  requestLogin: () => Promise<PublicUser>;
  isModalOpened: boolean;
  item: AdItem;
  onSendReplyCallback?: () => Promise<void>;
  buyerName?: string;
  search?: SearchData;
}
export const ContactForm = props => {
  const $ = _c(9);
  const {
    isPro,
    item,
    isMobile,
    isModalOpened,
    onCloseContactForm
  } = props;
  const useProLeadForm = isPro && item.category.id === CategoryID.Auto;
  const modalTitle = isPro ? "Contatta il venditore" : "Contatta l'utente";
  let t0;
  if ($[0] !== props || $[1] !== useProLeadForm) {
    t0 = useProLeadForm ? <ProLeadForm {...props} /> : <Form {...props} />;
    $[0] = props;
    $[1] = useProLeadForm;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const FormComponent = t0;
  let t1;
  if ($[3] !== FormComponent || $[4] !== isMobile || $[5] !== isModalOpened || $[6] !== modalTitle || $[7] !== onCloseContactForm) {
    t1 = isMobile ? <FullModal title={modalTitle} open={isModalOpened} onClose={onCloseContactForm}>{FormComponent}</FullModal> : FormComponent;
    $[3] = FormComponent;
    $[4] = isMobile;
    $[5] = isModalOpened;
    $[6] = modalTitle;
    $[7] = onCloseContactForm;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
};